import React from 'react';
import { Children, ChildWrapper, Card, InfoWrapper, Icon, Name, InfoLeft, InfoRight } from './styled'

const sampleChildren = [
  {
    name: 'Förnamn Efternamn',
    socialSecurityNumber: '20090101-1111',
    address: 'Storgatan 1',
    zipCode: '123 45',
    city: 'Storstaden'
  },
  {
    name: 'Förnamn Efternamn',
    socialSecurityNumber: '20110101-1111',
    address: 'Storgatan 1',
    zipCode: '123 45',
    city: 'Storstaden'
  }
]

export default props => {
  const { extra = {} } = props

  return (
    <Children>
      {
        sampleChildren.map((child, i) => {
          const { name, socialSecurityNumber, address, zipCode, city } = child

          return (
            <ChildWrapper key={i}>
              <Card
                selected={true} builder={true}
              >
                <InfoWrapper>
                  <Name>
                    {
                      extra.icon && <Icon className="far fa-child" />
                    }
                    {name}
                  </Name>
                </InfoWrapper>
                <InfoWrapper>
                  <InfoLeft>Personnr</InfoLeft>
                  <InfoRight>{socialSecurityNumber}</InfoRight>
                </InfoWrapper>
                <InfoWrapper>
                  <InfoLeft>Adress</InfoLeft>
                  <InfoRight>{address}</InfoRight>
                </InfoWrapper>
                <InfoWrapper>
                  <InfoLeft>Postnr</InfoLeft>
                  <InfoRight>{zipCode}</InfoRight>
                </InfoWrapper>
                <InfoWrapper>
                  <InfoLeft>Ort</InfoLeft>
                  <InfoRight>{city}</InfoRight>
                </InfoWrapper>
              </Card>
            </ChildWrapper>
          )
        })
      }
    </Children>
  )
}